/**
 * symbolUtils
 * -----------------
 * These functions are used internally by the Symbol components
 * to translate Symbol and/or Conditional State configuration to
 * React/HTML Element Attributes (`onClick`, `style`, etc).
 */
import { __assign } from "tslib";
/**
 * Process and merge styles from attribute map
 *
 * @param attributes attributes from conditionState
 * @param attributeMap symbol-specific map of styles for a certain attribute value
 */
export var applyAttributeStyles = function (attributes, attributeMap) {
    return Object.keys(attributeMap)
        // our AttributeStyleMap only applies to string values
        .filter(function (k) { return attributes[k] && typeof attributes[k] === 'string'; })
        .map(function (k) { return attributeMap[k][attributes[k]]; })
        .reduce(function (acc, style) { return (__assign(__assign({}, acc), style)); }, {});
};
/**
 * Build correct css style for background
 * when combine with gradient and pattern image
 * see: https://jsfiddle.net/dfn30wqj/2/
 */
export var buildBackgroundStyle = function (styles) {
    var _a = styles.background, background = _a === void 0 ? '' : _a, _b = styles.backgroundColor, backgroundColor = _b === void 0 ? '' : _b;
    return [background, backgroundColor, 'repeat'].join(' ');
};
/**
 * Join and clean className
 * - remove all undefined and empty
 */
export var joinClass = function () {
    var arg = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arg[_i] = arguments[_i];
    }
    return arg.filter(function (i) { return i; }).join(' ');
};
/**
 * Can this Symbol have children?
 */
export var isParent = function (symbol) {
    return ['scene', 'group', 'stage'].indexOf(symbol.type) !== -1;
};
